import React from 'react';
import { Button } from 'react-bootstrap';
//import { AddVerificationModal } from '../../InventoryPage/components/AddVerificationModal';
//import { EditVerificationModal } from '../../InventoryPage/components/EditVerificationModal';

function AddEditVerificationCell({ value, row }) {
  let rowData = {
    barCode: row.BarCodeNumber,
    verifyId: row.VerifyId,
    year: row.Year,
    assetsViewId: row.AssetID,
  };

  if (value != null) {
    return(
      <Button
        variant='primary'
        href={`/inventory/editVerification/verifyId=${rowData.verifyId}/${false}/false`}
      >
        <i className='fa fa-edit'/>
      </Button>
    )
    //return <EditVerificationModal data={rowData} disableFields={false} toTransfer={false} />;
  } else {
    let data = encodeURIComponent(JSON.stringify({barcode: rowData.barCode}))
    return(
      <Button
        variant='primary'
        href={`/inventory/create/${data}/b`}
      >
        <i className='fa fa-plus'/>
      </Button>
    )
    //return <AddVerificationModal data={rowData} />;
  }
}

export const columns = [
  {
    column: {
      Header: 'Edit',
      accessor: 'VerifyId',
      width: 50,
      filterable: false,
      resizable: true,
      Cell: AddEditVerificationCell,
    },
    type: 'number',
  },
  {
    column: {
      Header: 'Id',
      accessor: 'VerifyId',
      resizable: true,
      type: 'number',
    },
    type: 'number',
  },
  {
    column: {
      Header: 'Status',
      accessor: 'Status',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Barcode',
      accessor: 'BarCodeNumber',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Verify Date',
      accessor: 'VerifyDate',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'User Id',
      accessor: 'UserId',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Department Of User',
      accessor: 'departmentId',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Type',
      accessor: 'Type',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Department',
      accessor: 'Department',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Owner',
      accessor: 'owner',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Comments',
      accessor: 'allComments',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
];

export const gridOptions = {
  rowStyle: {
    color: 'black',
    background: '#D3D3D3',
    textAlign: 'center',
    textAlignVertical: 'center ',
    position: 'center',
    height: 10,
  },
  options: {
    defaultSortField: 'owner',
  },
  keyField: 'VerifyId',
  cellRenderer: function (id) {
    return (
      <a href={`/inventory/edit/${id}`} class='dark-link'>
        <i class='fa fa-edit' />
      </a>
    );
  },
  columnDefs: [
    {
      text: 'edit',
      width: 50,
    },
    {
      text: 'ID',
      dataField: 'VerifyId',
      width: 100,
      sort: true,
    },
    {
      text: 'Status',
      dataField: 'Status',
      width: 120,
      sort: true,
    },
    {
      text: 'Bar Code',
      dataField: 'BarCodeNumber',
      width: 120,
      sort: true,
    },
    {
      text: 'Verify Date',
      dataField: 'VerifyDate',
      sort: true,
    },
    {
      text: 'User ID',
      dataField: 'UserId',
      width: 100,
      sort: true,
    },
    {
      text: 'Department Of User',
      dataField: 'departmentId',
      width: 200,
      sort: true,
    },
    {
      text: 'Type',
      dataField: 'Type',
      width: 80,
      sort: true,
    },
    {
      text: 'Department',
      dataField: 'Department',
      width: 180,
      sort: true,
    },
    {
      text: 'Owner',
      dataField: 'owner',
      width: 100,
      sort: true,
    },
    {
      text: 'Comments',
      dataField: 'allComments',
      width: 570,
      sort: true,
    },
  ],
};
